import roles from './roles';

/**
 * Papéis com acesso a qualquer rota do painel (/painel/*).
 * Clientes finais (USER) e garçons (WAITER) ficam de fora e são
 * redirecionados para a listagem pública de eventos.
 */
export const DASHBOARD_ROLES = [roles.PRODUCER, roles.ESTABLISHMENT, roles.ADMIN];

/** Papéis com acesso ao painel do produtor (/painel/produtor/*). */
export const PRODUCER_ROLES = [roles.PRODUCER, roles.ESTABLISHMENT, roles.ADMIN];

/** Papéis com acesso ao painel do estabelecimento (/painel/estabelecimento/*). */
export const ESTABLISHMENT_ROLES = [roles.ESTABLISHMENT, roles.ADMIN];

export function hasRole(user, allowedRoles) {
    return allowedRoles.some((role) => role == user?.role?.id);
}

export function canAccessDashboard(user) {
    return hasRole(user, DASHBOARD_ROLES);
}
